<div class="d-flex justify-space-between">
  <div class="cursor align-items-center justify-content-start d-flex gap-10 mt-3 ml-3">
    <div
      matTooltip="Back"
      (click)="handleBack()"
    >
      <img alt="back" src="../../../../assets/images/arrow_circle_left.svg" />
    </div>
    <div class="insights-header">Case Insights</div>
  </div>
</div>

<div class="iframe-container">
    <!-- Iframe -->
    <iframe
      *ngIf="htmlUrl"
      [src]="htmlUrl"
      width="100%"
      height="750"
      style="border:none;"
      (load)="onIframeLoad()"
      (error)="onIframeError()"
      [style.display]="loading ? 'none' : 'block'">
    </iframe>
  </div>